const statisticsReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_STATISTICS':
            const newState = action.payload;
            return newState;
        case 'UNSET_STATISTICS':
            return [];
        default:
            return state;
    }
};

export default statisticsReducer;